import React, { Component } from 'react'
import { Popup } from 'devextreme-react/popup'
import Form from 'devextreme-react/form'
import { confirm, alert } from 'devextreme/ui/dialog'
import httpRequest from 'plugin/httprequest'
import { showLoading } from 'redux/actions/loading'

//copy paste this code to create new modal

class ModalNoteKlaim extends Component {
  constructor(props) {
    super(props)

    this.state = {
      popupVisible: false,
      note: {
        typeNote: 'kirim',
        notes: '',
        klaimId: null,
        participantId: null,
      },
    }

    this.PopupToolbarItem = [
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Batal',
          elementAttr: { class: 'bg-button-popup-close-dapen-default' },
          onClick: this.hide.bind(this),
        },
        toolbar: 'bottom',
      },
      {
        widget: 'dxButton',
        location: 'after',
        options: {
          text: 'Simpan',
          elementAttr: { class: 'bg-button-popup-save-dapen-default' },
          onClick: async () => {
            let confirms = await confirm(
              `Apakah Anda Yakin ${
                this.state.note.typeNote === 'kirim' ? 'Kirim' : 'Tolak'
              } Data Ini ?`,
              'Konfirmasi'
            )
            if (confirms) {
              await this.submitData()
            }
          },
        },
        toolbar: 'bottom',
      },
    ]

    this.formItems = [
      {
        dataField: 'notes',
        label: {
          visible: false,
          alignment: 'left',
          text: `${this.type} Notes`,
          location: 'left',
        },
        editorType: 'dxTextBox',
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
        },
      },
    ]

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
    this.onShown = this.onShown.bind(this)

    this.formRef = React.createRef()
  }

  show() {
    this.setState({
      popupVisible: true,
    })
  }

  onShown = (e) => {
    this.formRef.current.instance.getEditor('notes').focus()
  }

  hide() {
    this.setState({
      popupVisible: false,
      note: {},
    })
  }

  retrieveData = (klaimId, participantId, typeNote) => {
    if (klaimId) {
      this.setState({
        note: {
          klaimId: klaimId,
          participantId: participantId,
          typeNote: typeNote,
        },
      })
    }
  }

  submitData = async () => {
    const { note } = this.state
    console.log(note)

    if (note) {
      this.props.store.dispatch(showLoading(true))
      try {
        const api = 'ppip-klaims/send-klaim'
        if (note.typeNote === 'kirim') {
          await httpRequest(
            process.env.REACT_APP_BACKEND_CORE,
            this.props.store,
            api +
              `?id=${note.klaimId}&participantId=${
                note.participantId
              }&send=${true}`,
            'POST',
            {
              values: {
                note: note.notes,
              },
            }
          )
        } else {
          await httpRequest(
            process.env.REACT_APP_BACKEND_CORE,
            this.props.store,
            api +
              `?id=${note.klaimId}&participantId=${
                note.participantId
              }&send=${false}`,
            'POST',
            {
              values: {
                note: note.notes,
              },
            }
          )
        }

        this.props.store.dispatch(showLoading(false))
        let alerts = await alert(
          `${note.typeNote === 'kirim' ? 'Kirim' : 'Tolak'} Data Berhasil`,
          'Informasi!'
        )
        if (alerts) {
          this.hide()
          this.props.forceRefresh()
        }
      } catch (e) {
        console.error(e)
        this.props.store.dispatch(showLoading(false))
        alert(`Terjadi Kesalahan!`, 'Informasi!')
      }
    }
  }

  render() {
    return (
      <Popup
        className={'popup'}
        visible={this.state.popupVisible}
        onHiding={this.hide}
        dragEnabled={true}
        showTitle={true}
        title={`Catatan`}
        width={500}
        height={160}
        onShown={this.onShown}
        ref={this.PopupRef}
        toolbarItems={this.PopupToolbarItem}
      >
        <Form
          colCount={1}
          id={'formMaster'}
          formData={this.state.note}
          items={this.formItems}
          ref={this.formRef}
        />
      </Popup>
    )
  }
}

export default ModalNoteKlaim
